import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';

import { AngleLeftIcon } from '../../../../../../components/icon/solid';
import styles from "./styles";

type Props = {
  onClick: () => void;
}

const PreviousAction = ({ onClick }: Props) => {
  const classes = styles();

  return (
    <Tooltip
      title='Previous'
      PopperProps={{
        disablePortal: true,
      }}
    >
      <IconButton onClick={onClick} className={classes.button}>
        <AngleLeftIcon className={classes.icon}/>
      </IconButton>
    </Tooltip>
  )
};

export default PreviousAction;
